


const MemberServicesHero = () => {
  return (
    <section
      className="relative w-full flex items-center justify-center overflow-hidden"
      style={{
        height: 'calc(100vh - 68px)', // Full viewport height minus header height (36px logo + 32px padding)
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.6)), url('/Member Services/hero.jpg')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }}
    >
      {/* Hero Content */}
      <div className="relative z-20 text-center px-6 max-w-6xl mx-auto">
        <h1
          style={{
            fontFamily: 'Cardo, serif',
            fontSize: '80px',
            color: '#FFFFFF',
            fontWeight: '400',
            lineHeight: '1.1',
            textAlign: 'center',
            letterSpacing: '0.02em'
          }}
        >
          MEMBER SERVICES
        </h1>
      </div>
    </section>
  )
}

export default MemberServicesHero